import React from 'react'
import { Answer, Question } from '../../../../Api'
import { Percent } from '../../../../Utils'
import { MultiChoiceAnswerRow } from './MultiChoiceAnswerRow'

type QuestionProps = {
  question: Question
  answer: Answer
  isAnswered?: boolean
  selected: string | null
  correct: number
  uiTheme?: 'light' | 'dark'
  onSelect: (sel: string) => void
}

export const AnswerRowCon: React.FC<React.PropsWithChildren<QuestionProps>> = ({
  question,
  answer,
  selected,
  correct = 0,
  uiTheme,
  onSelect,
}) => {
  const isSelected = selected === answer.code ? true : false

  const calculatePercentage = (answerCount: number) => {
    const totalCount = question.answerChoices.reduce(
      (sum, a) => sum + a.count,
      0
    )
    if (totalCount === 0) return ''
    const fraction = answerCount / totalCount
    return Percent(fraction)
  }

  return (
    <MultiChoiceAnswerRow
      question={question}
      correct={correct}
      answer={answer}
      isSelected={isSelected}
      calculatePercentage={calculatePercentage}
      uiTheme={uiTheme}
      onSelect={onSelect}
    />
  )
}
